import React, { Component } from 'react'
import './index.scss'

export default class OnmailDiscontinue extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div className="full-width onmail-discontinue">
        <div
          className="background-frame-header background-image-fill"
          style={{ backgroundImage: 'url(/images/sunset-background.jpg)' }}
        >
          <div className="full-width full-height background-frame-overlay overlay">
            <div className="row full-height middle max-width-container">
              <div className="small-12 medium-12 large-12 padding-small centered-text">
                <h1 className="full-width white-text">So long...</h1>
              </div>
            </div>
          </div>
        </div>
        <div className="padding-small">
          <div className="max-width-container discontinue-email">
            <p>Dear OnMail Community,</p>
            <br />
            <p>
              It is with a heavy heart that we made the difficult decision to
              officially shut our doors on <b>July 31st, 2025</b>.
            </p>
            <br />
            <p>
              To our incredible community of creators, small business owners,
              and entrepreneurs - thank you. Your support, feedback, and passion
              for a better email experience were the driving forces behind
              everything we built. Together, we reimagined what email could be:
              modern, user-centric, and thoughtfully designed. We’re proud of
              what we accomplished, and of the community that believed in our
              mission.
            </p>
            <br />
            <p>
              I’d also like to express immense gratitude to the OnMail team.
              Building a fresh approach to email, one of the most widely used
              communication tools, was an ambitious task for a small team up
              against some of the biggest players in the tech world. The
              dedication, hard work, and sacrifices made by the team led to
              industry recognition, app store features, and coverage by major
              publishers, achievements that would not have been possible without
              their unwavering commitment.
            </p>
            <br />
            <p style={{ fontWeight: 700 }}>What to Know Now</p>
            <br />
            <p>
              OnMail services have now been fully discontinued. As of{' '}
              <b>July 31st</b>, all user accounts have been closed, and access
              to inboxes, data, and custom domain settings is no longer
              available.
            </p>
            <br />
            <p>
              If you have any questions or need assistance, please reach out to
              our&nbsp;
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://support.onmail.com/hc/en-us/requests/new?ticket_form_id=160323"
              >
                support team
              </a>
              . While the service is no longer active, we’re still here to help
              with any final concerns you may have.
            </p>
            <br />
            <p>
              Thank you again for being part of the OnMail journey. Your support
              meant the world to us.
            </p>
          </div>
        </div>
      </div>
    )
  }
}
